import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

export default function useRootUserMutations() {
  const app = useRealmApp();
  return {
    updateRootUser: useUpdateRootUser(app.currentUser.id),
  };
}

const UpdateRootUserMutation = gql`
  mutation UpdateRootUser(
    $rootUserId: ObjectId!
    $ownerId: String!
    $updates: RootUserUpdateInput!
  ) {
    updatedRootUser: updateOneRootUser(
      query: { _id: $rootUserId, owner_id: $ownerId }
      set: $updates
    ) {
      _id
      address1
      address2
      city
      color
      country
      email
      idNumber
      image
      language
      lastName
      name
      phone
      phone2
      qrData
      updateDatetime
    }
  }
`;

function useUpdateRootUser(ownerId) {
  const [updateRootUserMutation] = useMutation(UpdateRootUserMutation);
  return async (rootUser, updates) => {
    const {
      data: { updatedRootUser },
    } = await updateRootUserMutation({
      variables: { rootUserId: rootUser._id, ownerId, updates },
    });
    return updatedRootUser;
  };
}
